import * as React from 'react';
import { useEffect, useState } from 'react';
import userManager from '../../services/userManager';
import LoadingIndicator from '../ui/LoadingIndicator';

export default function LoginPage() {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [error, setError] = useState('Network Error');

  function login() {
    setIsRedirecting(true);
    setError('');

    const searchParams = new URLSearchParams(window.location.search);
    const user = searchParams.get('user')?.trim();
    const returnPath = searchParams.get('returnPath') || undefined;
    const isLikelyEmail = !!user && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user);

    userManager
      .signinRedirect({
        ...(returnPath ? { state: { returnPath } } : {}),
        ...(isLikelyEmail
          ? {
              extraQueryParams: {
                user,
              },
            }
          : {}),
      })
      .catch((error: any) => {
        setIsRedirecting(false);
        setError(error.message);
      });
  }

  useEffect(() => {
    login();
  }, []);

  if (error && !isRedirecting) {
    return (
      <div className="container">
        <div className="alert alert-danger">
          <div className="form-group">
            <strong>Error signing in:</strong> {error}
          </div>
          <button
            type="button"
            className="btn btn-primary"
            disabled={isRedirecting}
            onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => {
              e.preventDefault();
              login();
            }}
          >
            {isRedirecting ? <LoadingIndicator size="small" color="inverse" /> : <span>Retry Sign In</span>}
          </button>
        </div>
      </div>
    );
  }

  return <div className="loader">Loading...</div>;
}
